import { render, staticRenderFns } from "./Oblig.vue?vue&type=template&id=8567615c&scoped=true&"
import script from "./Oblig.vue?vue&type=script&lang=js&"
export * from "./Oblig.vue?vue&type=script&lang=js&"
import style0 from "./Oblig.vue?vue&type=style&index=0&id=8567615c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8567615c",
  null
  
)

export default component.exports